<div class="component-container flex flex-col justify-center items-center">
  <div class="msg text-center w-full mb-[2.5rem]">
    You have been idle for more than 90 minutes, <br> please login to continue
  </div>
  <div class="action-panel w-1/2 text-center">
    <app-primary-button
      (handleClick)="logout()"
      class="action-panel mt-[2.4rem] "
      type="small"
    >
      Ok
    </app-primary-button>
  </div>
</div>
